import React from 'react';

import delv from 'dlv';
import styled, { css } from 'styled-components';

import { IPickerAspectUiPattern } from '@rbi-ctg/menu';
import BonusPoints from 'components/bonus-points';
import RadioButton from 'components/radio-button';
import { PickerAspectUiPattern, isUiPatternRadio } from 'state/menu/types';

import NameAndCalories from './name-and-calories';
import PickerAspectOptionContainer from './picker-aspect-option-container';
import { IPickerAspectOptionProps } from './types';

const RadioButtonContainer = styled.div<IPickerAspectUiPattern>`
  align-items: center;
  display: flex;

  ${p =>
    isUiPatternRadio(p) &&
    css`
      position: absolute;
      z-index: 0;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
    `};
`;

const PickerAspectOption: React.FC<IPickerAspectOptionProps> = props => {
  const handleSelection = (event: any) => {
    event.preventDefault();

    if (props.disabled) {
      return;
    }
    props.handleSelection(props.option.identifier);
  };

  const name = props.option?.name?.locale;
  const uiPattern = delv(props, 'uiPattern', PickerAspectUiPattern.SELECTOR);
  const bonusPoints = props.aspectPromotion?.bonusPoints;

  return (
    <PickerAspectOptionContainer
      onClick={handleSelection}
      disabled={props.disabled}
      selected={props.selected}
      data-testid={`picker-aspect-option-${name}`}
      uiPattern={uiPattern}
    >
      <div>
        <NameAndCalories
          name={name}
          calories={props.calories}
          uiPattern={uiPattern}
          icon={props.icon}
          selected={props.selected}
        />
        {bonusPoints && <BonusPoints bonusPoints={bonusPoints} />}
      </div>
      <RadioButtonContainer uiPattern={uiPattern}>
        <RadioButton
          data-testid={name}
          option={props.option}
          checked={props.selected}
          disabled={props.disabled}
          inputName={props.inputName}
          onChange={() => {}}
          uiPattern={uiPattern}
          size={1.5}
          hideInput
        />
      </RadioButtonContainer>
    </PickerAspectOptionContainer>
  );
};

export default PickerAspectOption;
